import { GET_RADIOLOGIST_DASHBOARD } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getRadiologistDash = createAsyncThunk('getRadiologistDash', async (query: any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${GET_RADIOLOGIST_DASHBOARD}${query}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch analytics details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default getRadiologistDash;
